import { GzListItemWebComponent } from './component/GzListItemWebComponent';
import { WEB_COMPONENT_GZ_LIST_ITEM } from '../../webcomponents.constants';

export { GzListItemWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_LIST_ITEM, GzListItemWebComponent);
